// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"3c9d1aee","89":"82eb1ee9","372":"3765ae07","718":"8e9588db","720":"c80d686b"}[chunkId] + ".chunk.js";
};